/* ============================================================
   ELMORE — COLLECTION ATC (LET THEME HANDLE DRAWER)
   FINAL CLEAN VERSION
   ============================================================ */

(function () {
  if (window.__ELMORE_COLLECTION_CLEAN__) return;
  window.__ELMORE_COLLECTION_CLEAN__ = true;

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form.elmore-card__quickform[data-atc-form]')) return;

    const btn = form.querySelector('button[type="submit"]');
    if (!btn) return;

    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent.trim();
    }

    btn.disabled = true;
    btn.textContent = 'Adding…';

    // Let Broadcast theme handle the submission normally
    // Do NOT preventDefault
  });

  // Restore button text after drawer updates
  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('form.elmore-card__quickform button[type="submit"]').forEach(btn => {
      if (btn.dataset.originalText) {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText;
      }
    });
  });


  // Always open the mobile cart at the product pane. The outer drawer must
  // never retain a scroll offset from an older single-scroll implementation.
  function resetCartDrawerPosition() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    var body = drawer.querySelector('.drawer__body');
    var foot = drawer.querySelector('.drawer__foot');
    if (inner) inner.scrollTop = 0;
    if (body) body.scrollTop = 0;
    if (foot) foot.scrollTop = 0;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-cart-drawer-open], [data-cart-toggle], a[href="/cart"]');
    if (!trigger) return;
    requestAnimationFrame(function () {
      resetCartDrawerPosition();
      setTimeout(resetCartDrawerPosition, 80);
      setTimeout(resetCartDrawerPosition, 260);
    });
  }, true);

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (cartDrawer.classList.contains('is-open') || cartDrawer.classList.contains('drawer--visible')) {
        requestAnimationFrame(resetCartDrawerPosition);
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }


  // Premium cart response: instant open, dependable one-tap close.
  document.addEventListener('theme:cart:add', function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !window.cart || typeof window.cart.openCartDrawer !== 'function') return;
    drawer.classList.add('dt-cart-pending');
    if (!drawer.classList.contains('is-open')) {
      window.cart.openCartDrawer();
    }
  }, true);

  document.addEventListener('theme:product:added', function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.classList.remove('dt-cart-pending');
  });

  document.addEventListener('theme:product:add-error', function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.classList.remove('dt-cart-pending');
  });

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest && event.target.closest('[data-cart-drawer-close]');
    if (!closeButton) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (window.cart && typeof window.cart.closeCartDrawer === 'function') {
      window.cart.closeCartDrawer();
    }
  }, true);

})();
